import appModuleRegistry from "components/appModules/appModuleRegistry";
import { S6Request } from "components/request/request";
import { NotificationBadgeElement } from "./notificationBadge";
import { NotificationBadgeData } from "./notificationBadge";

const template = document.createElement("template");
template.innerHTML = `
<notification-badge></notification-badge>
`;
export class NotificationSSEElement extends HTMLElement {
  private _shadowRoot: ShadowRoot;
  private evtSource: EventSource;
  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this._shadowRoot.appendChild(template.content.cloneNode(true));
  }

  private connectedCallback() {
    let url = this.getAttribute("url");
    url = appModuleRegistry.prefixUrl(url);
    this.evtSource = new EventSource(url, { withCredentials: true });
    this.evtSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data === "ping") {
        return;
      }
      this.data = data;
    };
    this.evtSource.onerror = (event) => {
      console.warn(event);
    };
  }

  private disconnectedCallback() {
    this.evtSource.close();
  }

  public set data(data: NotificationBadgeData) {
    let badge = (this._shadowRoot.querySelector("notification-badge") as NotificationBadgeElement);
    badge.data = data;
  }
}

export function initNotificationBadgeSSEWebComponent() {
  window.customElements.define("notification-sse", NotificationSSEElement);
}
